import SoftOfferPackage from '../../entities/campaigns/tps/SoftOfferPackage';

export default class SoftOfferPackageFactory {

  static create(softOfferPackage: SoftOfferPackage): SoftOfferPackage {
    return new SoftOfferPackage(
      softOfferPackage.id,
      softOfferPackage.cosmosSubscription,
      softOfferPackage.dsNumber,
      softOfferPackage.maxDsNumber,
      softOfferPackage.img,
      softOfferPackage.sms,
      softOfferPackage.min,
      softOfferPackage.mint,
      softOfferPackage.minr,
      softOfferPackage.data,
      softOfferPackage.datar,
      softOfferPackage.rzb,
      softOfferPackage.rzbm,
      softOfferPackage.name,
      softOfferPackage.priority,
      softOfferPackage.subscription,
      softOfferPackage.tmCode,
      softOfferPackage.url,
      softOfferPackage.benefits,
      softOfferPackage.youth,
      softOfferPackage.smartic,
      softOfferPackage.home,
      softOfferPackage.drivey,
      softOfferPackage.services,
      softOfferPackage.infoUrl,
      softOfferPackage.recommended,
      softOfferPackage.usage
    );
  }

}
